<template>
  <v-card class="card-pad text-center pa-6">
    <v-btn absolute top right icon text @click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <h3 class="mr-6">
      {{ isEditing ? $t('Atualizar') : $t('Adicionar') }} Fabricante
    </h3>

    <v-form ref="form">
      <v-row class="ma-0">
        <v-col>
          <v-text-field
            v-model="manufacturer.name"
            class="primary-input"
            :placeholder="$t('Nome')"
            hide-details="auto"
            outlined
            :rules="[(v) => !!v || $t('Nome obrigatório')]"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <div class="d-flex justify-end">
      <v-btn
        class="mr-0 secondary-button"
        :loading="loading"
        block
        depressed
        @click="submit"
      >
        {{ $t('Salvar') }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
export default {
  name: 'ManageManufacturer',

  props: {
    id: Number,
  },

  data() {
    return {
      apiService: new ApiService(),
      isEditing: false,
      loading: false,
      manufacturer: {},
      institutionId: '',
    }
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    if (this.id) {
      this.isEditing = true
      this.getData()
    }
  },

  methods: {
    getData() {
      this.loading = true
      this.apiService
        .get(`manufacturer/${this.id}`)
        .then((response) => {
          this.loading = false
          this.manufacturer = response.content
        })
        .catch(() => {
          this.loading = false
        })
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true

        let url = this.isEditing ? 'manufacturer/edit' : 'manufacturer/add'

        this.manufacturer.name = (this.manufacturer.name || '').trim()
        this.manufacturer.institutionId = this.institutionId

        this.apiService
          .post(url, this.manufacturer)
          .then(() => {
            this.loading = false
            this.$emit('confirm')
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
